/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { AmiTableTemplate } from 'src/app/@amiga-pyme/templates/ami-table.template';
import { IActions, IEventAction } from './ami-table.interface';
@Component({
  selector: 'ami-table',
  templateUrl: './ami-table.component.html'
})
export class AmiTableComponent extends AmiTableTemplate {
  @Output() action = new EventEmitter<IEventAction>();
  actions: IActions = {
    update: true,
    delete: true,
    create: true
  };
  deleteItemDialog = false;
  rowToDelete: unknown;

  ngOnChanges(changes: SimpleChanges) {
    const settings = this.settings;
    this._selectedColumns = settings.columns;
    const changesData = changes?.data.currentValue;
    if (changesData) {
      this.listingData = false;
      this.data = changesData;
    }
  }

  editRow(rowData: unknown) {
    this.action.emit({ action: 'update', data: rowData });
  }

  addRow() {
    this.action.emit({ action: 'create' });
  }

  deleteRow(rowData: unknown) {
    this.rowToDelete = rowData;
    this.deleteItemDialog = true;
  }

  confirmDeleteSelected() {
    this.action.emit({ action: 'delete', data: this.rowToDelete });
    this.deleteItemDialog = false;
  }

  onShowColumnAction() {
    return this.actions.update || this.actions.delete;
  }
}
